"use client";

import React from "react";
import { ImageWrapper, Text } from "ui-components";

import { JobResponseEntity } from "@/hooks/api/generated";
import { getOrganizationImages } from "@/utils/organization";

export function OrganizationInfo({
  jobDetails,
}: {
  jobDetails: JobResponseEntity;
}): JSX.Element {
  const { logoImageUrl } = getOrganizationImages(
    jobDetails?.organization,
    true
  );
  return (
    <div className="w-full flex items-center gap-4 md:hidden">
      {logoImageUrl ? (
        <div className="w-[68px] h-[68px]">
          <ImageWrapper
            src={logoImageUrl}
            width={68}
            height={68}
            alt={`${jobDetails?.organization?.name} logo image`}
            className="rounded-[10px] border w-[68px] h-[68px]"
            style={{
              objectFit: "cover",
            }}
            isCLDImage
          />
        </div>
      ) : null}
      <div className="flex flex-col gap-1">
        <Text variant="large">{jobDetails?.organization?.name}</Text>
        <Text variant="small">{jobDetails?.organization?.industry.name}</Text>
      </div>
    </div>
  );
}
